import { v4 as uuidv4 } from 'uuid';

export interface ITransform {
    source?: string;
    transform?: string;
}
export class AModel {
    public guid: string = null;
    public values: any = null;
    public defaults: any = null;
    public fillables: any = null;
    public transformAs: string = null;

    get isCollection (): boolean {
        return this.values && this.values.constructor && this.values.constructor.name === 'Array';
    }
    constructor (args?: any) {
        // Set Model Guid //
        this.guid = uuidv4();
    }
    init (args: any, context?: AModel) {
        // Instantiate Collection //
        if (args && args && args.constructor && args.constructor.name === 'Array')
        {
            let values = [];
            for (var i = 0; i < args.length; i++) {
                // Instantiate a new class from the current instance //
                values = values.concat(new (<any> this.constructor)(args[i]));
            }
            this.values = values;
            return;
        }
        if (args && !this.isCollection)
        {
            this.set(args);
        }
    }
    find (guid: string): AModel {
        if (!this.isCollection) throw ("Error: Unable to use `find(guid: string)` in a single model.");
        if (this.values && this.isCollection)
        {
            if (this.values.length !== undefined)
            {
                const match = this.values.filter(x => x.guid === guid);
                if (match && match.length !== undefined)
                {
                    return match[0];
                }
            }
        }
        return null;
    }
    set (key: string, value?: any) {
        if (this.isCollection) throw ("Error: Unable to use `set(key: string, value?: any)` method in a collection model.");
        if (!key) return;
  
        if (value === undefined) {
          // Set all values
          value = key;
          let keys = Object.keys(value);
          for (let i = 0; i < keys.length; i++) {
            this.set(keys[i], value[keys[i]]);
          }
          return;
        }
 
        // Check if Model
        if (typeof (this.fillables[key]) === 'function' && value) {
            try {
                // To Prevent Re-instantiation of the object //
                if (!(value && typeof(value.transform) === 'function'))
                {
                    let tmp = new this.fillables[key](value);
                    if (typeof(tmp.init) === 'function') value = tmp;
                }
            } catch (err) {
            }
        }
  
        // _{field}Handler - function to modify or format value of a field.
        if (typeof (this['_' + key + 'Handler']) === 'function') value = this['_' + key + 'Handler'](value);
        if (typeof (this.fillables[key]) === 'string') {
            let tempKey = this.fillables[key];
            if (typeof (this['_' + tempKey + 'Handler']) === 'function') {
                value = this['_' + tempKey + 'Handler'](value);
            }
        }
        if (!this.values) this.values = {...this.defaults};
  
        // Set value
        this.values[key.toString()] = value;
    }
    getFillables (source: any): ITransform[] {
        let keys = Object.keys(source);
        let transforms = [];
        for (let i = 0; i < keys.length; i++)
        {
            let key = keys[i];
            let transform = key;
            if (typeof(source[key]) === 'function')
            {
                if (source[key].transformAs) {
                    transform = source[key].trnsformAs;
                }
            } else {
                transform = source[key];
            }
            transforms.push(<ITransform> {
                transform,
                source: key,
            });
        }
        return transforms;
    }
    get (key?: string, fallback?: any) {
        if (this.isCollection) throw ("Error: Unable to use `get(key? string, fallback?: any)` method in a collection model. key " + key);
        key = key.toString();
        if (!this.fillables[key]) {
            const transforms = this.getFillables(this.fillables);
            const values = transforms.filter(x => x.transform === key);
            if (values.length > 0) {
                key = values[0].source;
            }
        }
        const modelValues = this.defaults || this.values ? {
            ...(this.defaults ? this.defaults : {}),
            ...(this.values ? this.values : {})
        } : null;
        if (modelValues && modelValues[key]) return modelValues[key];
        return fallback === undefined ? null : fallback;
    }
    transform (keyDefinitions?: any) {

        // Check if associative arrays //
        if (this.isCollection)
        {
            if (!this.values)
            {
                return [];
            }
            return this.values.map(x => {
                return x.transform();
            });
        }

        let transformKeys = this.getFillables(this.fillables);
        const isOnly = keyDefinitions && keyDefinitions.length !== undefined;
        if (keyDefinitions && !isOnly) {
            transformKeys = this.getFillables(keyDefinitions);
        }
        const transformed = {};
        const values = {
            ...(this.defaults ? this.defaults : {}),
            ...(this.values ? this.values : {})
        };
        if (values)
        {
            for (let i = 0; i < transformKeys.length; i++)
            {
                const transformer: ITransform = transformKeys[i];
                if (transformer && transformer.source)
                {
                    let value = values[transformer.source];
                    if (value || typeof (value) === 'boolean' || typeof (value) === 'number')
                    {
                        if (value && typeof (value.transform) === 'function') {
                            value = value.transform();
                        }
                        transformed[transformer.transform] = value;
                    }
                    // Process Array //
                    if (value && typeof (value) === 'object' && value.length !== undefined)
                    {
                        const currentValue = value;
                        for (let x = 0; x < value.length; x++)
                        {
                            if (value[x] && typeof (value[x].transform) === 'function') {
                                value[x] = value[x].transform();
                            }
                            currentValue[x] = value[x];
                        }
                        transformed[transformer.transform] = currentValue;
                    }
                }
            }
        }
        return transformed;
      }
}


// WEBPACK FOOTER //
// ./src/app/api/abstracts/model.abstract.ts